import Vue from 'vue'
import ElementUI from 'element-ui';
//import { Row, Button, Container, Aside, Header, Main } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import Cookie from 'js-cookie'
import 'default-passive-events'
import AMap from 'vue-amap'
import '@/assets/mobile.less'

Vue.config.productionTip = false
Vue.use(ElementUI);
// Vue.use(Row);   // 将Element组件 按需注入 到Vue中
// Vue.use(Button);
// Vue.use(Container);
// Vue.use(Aside);
// Vue.use(Header);
// Vue.use(Main);
Vue.use(AMap)
AMap.initAMapApiLoader({
  key: "9f8eb22902ff76102e32ba52c7dee1e6",
  plugin: [
    "AMap.AutoComplete", //输入提示插件
    "AMap.PlaceSearch", //POI搜索插件
    "AMap.Scale", //右下角缩略图插件 比例尺
    "AMap.OverView", //地图鹰眼插件
    "AMap.ToolBar", //地图工具条
    "AMap.MapType", //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    "AMap.PolyEditor", //编辑 折线多，边形
    "AMap.PolygonEditor", //编辑 折线多，边形
    "AMap.CircleEditor", //圆形编辑器插件
    "AMap.Geolocation", //定位控件，用来获取和展示用户主机所在的经纬度位置
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: "2.0",
})
// 使用高德，需要配置安全密钥
/*window._AMapSecurityConfig = {
  securityJsCode: "7da9b57f393f8be874c085dc7745db1e",
};*/


import { getUsers } from './api'
// 添加全局前置导航守卫
router.beforeEach((to, from, next) => {
  const regex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i;
  const ismobile = regex.test(navigator.userAgent);
  if (ismobile) {
    store.commit('collapseMenu', ismobile);
    let _name = to.path.substring(to.path.lastIndexOf('/') + 1, to.path.length)
    document.body.className = `cyy_mobile_${_name}`
  }
  // 判断token是否存在
  const token = Cookie.get('token');
  console.log('try to get token:', token)
  // 如果token不存在，说明当前用户未登录，跳转到登录页面
  if (to.name == 'login') {
    Cookie.remove('token');
    next()
  }
  else if (!token && to.name !== 'login') {
    next({ name: "login" });
  } else if (token) {
    if (store.state.user.username) {
      getUsers(1, 1).then((data) => {
        if (store.state.user.authAcc.includes(store.state.user.username)) {
          let _menuData = store.state.user.authMenu
          if (_menuData.includes(to.path)) {
            next()
          } else {
            next({ name: "login" });
          }
        } else {
          if (data.data.code == 109) {
            Cookie.remove('token');
            next({ name: "login" });
          }
          else if (to.name === 'login')
            next({ name: "home" });
          else
            next();
        }
      });
    } else {
      next({ name: "login" });
    }
  } else {
    next();
  }
})

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')